import { render } from "./CreateSprite.vue?vue&type=template&id=1b8b01fd"
import script from "./CreateSprite.vue?vue&type=script&lang=ts"
export * from "./CreateSprite.vue?vue&type=script&lang=ts"
script.render = render

export default script